import React, { useEffect } from "react";
import Flatpickr from "react-flatpickr";
import { useState } from "react";
import {
  currentDateSingle,
  formatIndianCurrency,
  textDateFormatter,
} from "../../utils/utils";
import VendorHeader from "../../CustomComponents/Property/VendorHeader/VendorHeader";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import SideBar from "../../CustomComponents/Property/SideBar/SideBar";
import { showErrorToast, showSuccessToast } from "../../assets/toastUtils";

const RatesBulkUpdate = ({ onClose }) => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const vendorToken = localStorage.getItem("token");
  const [startDate, setStartDate] = useState(currentDateSingle);

  const { id } = useParams();

  const navigate = useNavigate();

  const [resultArray, setResultArray] = useState([]);
  const [ratesData, setRatesData] = useState([]);
  const [ratePlan, setRatePlan] = useState([]);

  const [rooms, setRooms] = useState([]);
  const [selectedRoomDetailsArray, setSelectedRoomDetailsArray] = useState([]);

  const { id: propertyId } = useParams();

  const [selectedRoomDetails, setSelectedDetails] = useState({
    roomId: "",
    mealPlanID: "",
    price: "",
    child_w_bed: "",
    child_wo_bed: "",
    extra_adult: "",
  });


  const handleDetailsChange = (e) => {
    const { name, value } = e.target;
    setSelectedDetails({
      ...selectedRoomDetails,
      [name]: value,
    });
  };

  // const handleAdd = () => {
  //   const roomType = rooms.find(
  //     (data) => +data.id === +selectedRoomDetails.roomId
  //   );
  //   if (!roomType) return toast.error("Room not found!");

  //   const mealPlan = ratePlan.find(
  //     (plan) => +plan.id === +selectedRoomDetails.mealPlanID
  //   );
  //   if (!mealPlan) return toast.error("Meal Plan not found!");

  //   const isDuplicate = selectedRoomDetailsArray.some(
  //     (item) =>
  //       item.roomId === selectedRoomDetails.roomId &&
  //       item.mealPlanID === selectedRoomDetails.mealPlanID
  //   );
  //   if (isDuplicate)
  //     return toast.error(
  //       "Duplicate meal plan for the same room is not allowed!"
  //     );

  //   const newEntry = {
  //     ...selectedRoomDetails,
  //     roomName: roomType.name,
  //     mealPlanName: mealPlan.name,
  //     mealPlanType: mealPlan.type,
  //   };

  //   setSelectedRoomDetailsArray([newEntry]);

  //   setSelectedDetails({
  //     roomId: "",
  //     mealPlanID: "",
  //     price: "",
  //     child_w_bed: "",
  //     child_wo_bed: "",
  //     extra_adult: "",
  //   });
  // };

  const handleAdd = () => {
    if (
      selectedRoomDetails.child_w_bed === "" ||
      selectedRoomDetails.child_wo_bed === "" ||
      selectedRoomDetails.extra_adult === "" ||
      selectedRoomDetails.price === "" ||
      selectedRoomDetails.roomId === "" ||
      selectedRoomDetails.mealPlanID === ""
    ) {
      toast.error("Please enter all details!");
      return;
    }
    const roomType = rooms.find(
      (data) => +data.id === +selectedRoomDetails.roomId
    );
    if (!roomType) return toast.error("Room not found!");

    const mealPlan = ratePlan.find(
      (plan) => +plan.id === +selectedRoomDetails.mealPlanID
    );
    if (!mealPlan) return toast.error("Meal Plan not found!");
    const isDuplicate = selectedRoomDetailsArray.some(
      (item) =>
        item.roomId === selectedRoomDetails.roomId &&
        item.mealPlanID === selectedRoomDetails.mealPlanID
    );
    if (isDuplicate)
      return toast.error(
        "Duplicate meal plan for the same room is not allowed!"
      );
    const newEntry = {
      ...selectedRoomDetails,
      roomName: roomType.name,
      mealPlanName: mealPlan.name,
      mealPlanType: mealPlan.type,
    };

    setSelectedRoomDetailsArray((prevArray) => [...prevArray, newEntry]);

    setSelectedDetails({
      roomId: "",
      mealPlanID: "",
      price: "",
      child_w_bed: "",
      child_wo_bed: "",
      extra_adult: "",
    });
  };

  const handleRemove = (index) => {
    setSelectedRoomDetailsArray((prevArray) =>
      prevArray.filter((_, i) => i !== index)
    );
  };

  const getRooms = async (id) => {
    // setLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Authorization", `Bearer ${vendorToken}`);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/accomodation/rooms/list/${id}`,
        requestOptions
      );
      const result = await response.json();
      setRooms(result?.data);
      // setLoader(false);
    } catch (error) {
      console.log(error.message);
      // setLoader(false);
    }
  };

  const fetchRatePlan = async (roomId) => {
    if (!propertyId || !roomId) return;

    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Authorization", `Bearer ${vendorToken}`);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/accomodation/rate-plans/${propertyId}/list/${roomId}`,
        requestOptions
      );
      const result = await response.json();
      setRatePlan(result?.data || []);
    } catch (error) {
      console.error("Error fetching rate plan:", error);
    }
  };

  useEffect(() => {
    if (propertyId) {
      getRooms(propertyId);
    }
  }, [propertyId]);

  useEffect(() => {
    if (selectedRoomDetails.roomId) {
      fetchRatePlan(selectedRoomDetails.roomId);
    }
  }, [selectedRoomDetails.roomId]);

  const reversedData = (formattedData) => {
    return formattedData
      .filter((room) => room.rate && Object.keys(room.rate).length > 0) // Filter out rooms without rateplans
      .map((room) => ({
        room_id: room.id,
        rateplans: Object.keys(room.rate).map((ratePlanKey, index) => {
          const [name, typeInBrackets] = ratePlanKey.split(" (");
          return {
            id: room.rate[ratePlanKey][index]?.ratePlanId || null,
            room_rate_plan_id:
              room.rate[ratePlanKey][index]?.ratePlanId || null,
            price: "",
            extra_adult: "",
            child_w_bed: "",
            child_wo_bed: "",
          };
        }),
      }));
  };

  const handleInputChange = (e, roomIndex, rateIndex, fieldName) => {
    const { value } = e.target;

    const parsedValue =
      fieldName === "price" ||
        fieldName === "extra_adult" ||
        fieldName === "child_w_bed" ||
        fieldName === "child_wo_bed"
        ? parseFloat(value) || 0
        : value;

    const updatedRatesData = [...ratesData];
    updatedRatesData[roomIndex].rateplans[rateIndex][fieldName] = parsedValue;
    setRatesData(updatedRatesData);
  };

  // const [ratesDataNew, setRatesDataNew] = useState([]);

  // const [updatePopup, setUpdatePopup] = useState(false);

  // useEffect(() => {
  //   // Function to process the room data
  //   const processRoomRates = (data) => {
  //     const processedData = data.map(room => {
  //       const roomRates = Object.entries(room.rate).flatMap(([planType, rates]) => {
  //         return rates.map(rate => ({
  //           ...rate,
  //           planType,
  //           roomName: room.name
  //         }));
  //       });
  //       return { roomName: room.name, roomRates };
  //     });
  //     return processedData;
  //   };

  //   const processedData = processRoomRates(ratesData);
  //   console.log(processedData);
  // }, [ratesData]);

  // const ratesDetails = (propertyId) => {
  //   const myHeaders = new Headers();
  //   myHeaders.append("key", process.env.REACT_APP_API_KEY);

  //   const requestOptions = {
  //     method: "GET",
  //     headers: myHeaders,
  //     redirect: "follow",
  //   };

  //   fetch(
  //     `${process.env.REACT_APP_APP_URL}/api/v1/vendor/hotel-rates/${propertyId}/bulk-update`,
  //     requestOptions
  //   )
  //     .then((response) => response.json())
  //     .then((result) => {
  //       // console.log(result);

  //       if (result.success) {
  //         setRatesData(result?.rooms);
  //       } else {
  //       }
  //       // console.log(result);
  //     })
  //     .catch((error) => console.error(error));
  // };

  const fetchRoomRates = async (propertyId) => {
    try {
      const headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", `Bearer ${vendorToken}`);
      headers.append("Cookie", process.env.REACT_APP_COOKIE);

      const formData = new FormData();
      formData.append("filterDate", startDate);

      const requestOptions = {
        method: "POST",
        headers: headers,
        body: formData,
        redirect: "follow",
      };

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/accomodation/room-rates/fetch/${propertyId}`,
        requestOptions
      );
      const result = await response.json();
      const newData = reversedData(result?.data);
      setRatesData(newData);
    } catch (error) {
      console.error("Error fetching room rates:", error);
    }
  };

  useEffect(() => {
    if (id) {
      // ratesDetails(id);
      fetchRoomRates(id);
    }
  }, [id]);

  const handleClosePopup = (e) => {
    onClose();
  };

  // useEffect(() => {
  //   if (ratesData) {
  //     const inventoryNewData = ratesData.map((data) => {
  //       return {
  //         room_name: data.id,
  //         inventory: "",
  //         rateplans: data.rateplans.map((rate) => {
  //           return {
  //             plan_name: rate.id,
  //             name: rate.name,
  //             contracted_rate: "",
  //             base_rate: "",
  //             extra_adult_rate: "",
  //             child_w_bed_rate: "",
  //             child_wo_bed_rate: "",
  //           };
  //         }),
  //       };
  //     });
  //     setResultArray(inventoryNewData);
  //   }
  // }, [ratesData]);

  useEffect(() => {
    if (ratesData) {
      const inventoryNewData = ratesData.map((data) => {
        return {
          room_name: data.id,
          inventory: "",
          rateplans: data?.rateplans?.map((rate) => {
            return {
              plan_name: rate.id,
              name: rate.name,
              contracted_rate: "",
              base_rate: "",
              extra_adult_rate: "",
              child_w_bed_rate: "",
              child_wo_bed_rate: "",
            };
          }),
        };
      });
      setResultArray(inventoryNewData);
    }
  }, [ratesData]);

  // console.log(resultArray, 'resultArray');

  const onChangeHandler = (e, index) => {
    const { name, value } = e.target;
    const newArray = [...resultArray];
    newArray[index][name] = value;
    setResultArray(newArray);
  };

  // const handleOnUpdate = () => {
  //   const myHeaders = {
  //     "Content-Type": "application/json",
  //     key: "D4X50uU40Vz4pweFLEmsoiJy107iPfTD4ompprop1",
  //     token: `Bearer ${localStorage.getItem("token")}`,
  //   };

  //   const requestOptions = {
  //     method: "PUT",
  //     headers: myHeaders,
  //     body: raw,
  //     redirect: "follow",
  //   };

  //   fetch(
  //     `${process.env.REACT_APP_APP_URL}/api/v1/vendor/hotel-rates/${id}/bulk-update`,
  //     requestOptions
  //   )
  //     .then((response) => response.json())
  //     .then((result) => {
  //       if (result.success) {
  //         toast.success(result.message);
  //         navigate(`/partner/rates/${id}`);
  //       }
  //     })
  //     .catch((error) => console.error(error));
  // };

  const urlParams = new URLSearchParams(window.location.search);
  const updateType = urlParams.get("type");

  const handleOnUpdate = async () => {
    const convertToPostData = (selectedRoomDetailsArray) => {
      const postData = [];

      selectedRoomDetailsArray.forEach((item) => {
        // Check if the roomId is already in the postData array
        let roomEntry = postData.find((room) => room.room_id === item.roomId);

        if (!roomEntry) {
          // If the room ID is not found, create a new entry
          roomEntry = {
            room_id: Number(item.roomId), // Convert roomId to a number
            name: item.roomName,
            rateplans: [],
          };
          postData.push(roomEntry);
        }

        // Add ratePlan only if it doesn't already exist in the rateplans array
        const existingRatePlan = roomEntry.rateplans.find(
          (rate) => rate.id === Number(item.mealPlanID) // Compare converted number IDs
        );

        if (!existingRatePlan) {
          roomEntry.rateplans.push({
            id: Number(item.mealPlanID), // Convert ID to a number
            name: item.mealPlanName,
            type: item.mealPlanType,
            room_rate_plan_id: Number(item.mealPlanID), // Convert to number
            price: Number(item.price), // Convert price to number
            child_w_bed: Number(item.child_w_bed), // Convert to number
            child_wo_bed: Number(item.child_wo_bed), // Convert to number
            extra_adult: Number(item.extra_adult), // Convert to number
          });
        }
      });

      return postData;
    };
    try {
      const myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${vendorToken}`);
      myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

      const raw = JSON.stringify({
        type: updateType ? updateType : "live",
        "from-date": fromDate,
        "to-date": toDate,
        rooms: convertToPostData(selectedRoomDetailsArray),
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/accomodation/rate-plans/bulk/rate/update/${id}`,
        requestOptions
      );
      const result = await response.json();
      if (result.success) {
        showSuccessToast(result.message);
        navigate(`/vendor/property/rates/${id}`);
      } else {
        showErrorToast(result.message);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <>
      {/* <div className="sidebar_main_div new_sidebar_main_div"> */}
      {/* <SideBar allPropertiesPage={false} />
        <div className="agent-info-container">
          <VendorHeader showSelectProperty={true} vendorProperty={false} /> */}

      <div
        className="inventory_update mt-20 w-full"
        style={{ borderRadius: "15px" }}
      >
        <div className="flex justify_content_between">
          <h4>Rates Bulk Update</h4>
          <div className="close_popup"></div>
        </div>
        <div>
          <form action="" className="mt-10">
            <div className="input-flex">
              <div>
                <label>From Date</label>
                <input
                  className="w-full"
                  type="date"
                  value={fromDate}
                  min={new Date().toISOString().split("T")[0]}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </div>
              <div>
                <label>To Date</label>
                <input
                  className="w-full"
                  type="date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  min={fromDate}
                />
              </div>
            </div>
            <div className="input-flex mt-10">
              <div>
                <label>Room Type</label>
                <select
                  className="w-full"
                  value={selectedRoomDetails.roomId}
                  onChange={handleDetailsChange}
                  name={"roomId"}
                  disabled={fromDate && toDate ? false : true}
                >
                  {" "}
                  <option value="">Select an option</option>
                  {rooms?.map((room) => (
                    <option key={room.id} value={room.id}>
                      {room.name}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label>Meal Plan</label>
                <select
                  className="w-full"
                  name={"mealPlanID"}
                  value={selectedRoomDetails.mealPlanID}
                  onChange={handleDetailsChange}
                  disabled={selectedRoomDetails.roomId ? false : true}
                // value={selectedRoomId}
                // onChange={(e) => setSelectedRoomId(e.target.value)}
                >
                  {" "}
                  <option value="">Select an option</option>
                  {ratePlan?.map((meal) => (
                    <option key={meal.id} value={meal.id}>
                      {meal.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </form>
          {/* {ratesData?.map((item, roomIndex) => {
            return (
              <div className="">
                <div className=""> */}
          {/* <span className=" block">
                    {" "}
                    <b>{ratesData[roomIndex].name}</b>{" "}
                  </span>
                  <input
                        type="number"
                        name="inventory"
                        style={{ width: "50px" }}
                        value={item?.inventory}
                        onChange={(e) => onChangeHandler(e, index)}
                      /> */}
          <div className="">
            {/* {item?.rateplans?.map((rate, rateIndex) => { */}
            {/* return ( */}
            {/* <div key={rateIndex}> */}
            <div>
              {/* <div className="">
                            <small className="font_12">{rate?.name}</small>
                          </div> */}
              <div className="justify_content_between w-100 form-flex-div mt-10">
                {/* <div>
                                <div>Contracted Rate</div>
                                <div>
                                  <input
                                    type="text"
                                    value={rate.contracted_rate}
                                    onChange={(e) => handleInputChange(e, roomIndex, rateIndex, 'contracted_rate')}
                                  />
                                </div>
                              </div> */}
                <div>
                  <div>Base Rate</div>
                  <div>
                    <input
                      className="w-100"
                      type="number"
                      name="price"
                      value={selectedRoomDetails.price}
                      onChange={handleDetailsChange}
                      disabled={
                        selectedRoomDetails.roomId &&
                          selectedRoomDetails.mealPlanID
                          ? false
                          : true
                      }
                    />
                  </div>
                </div>
                <div>
                  <div>Extra Adult Rate</div>
                  <div>
                    <input
                      type="number"
                      name="extra_adult"
                      className="w-100"
                      value={selectedRoomDetails.extra_adult}
                      onChange={handleDetailsChange}
                      disabled={
                        selectedRoomDetails.roomId &&
                          selectedRoomDetails.mealPlanID
                          ? false
                          : true
                      }
                    />
                  </div>
                </div>
                <div>
                  <div>Child with Bed Rate</div>
                  <div>
                    <input
                      className="w-100"
                      type="number"
                      name="child_w_bed"
                      value={selectedRoomDetails.child_w_bed}
                      onChange={handleDetailsChange}
                      disabled={
                        selectedRoomDetails.roomId &&
                          selectedRoomDetails.mealPlanID
                          ? false
                          : true
                      }
                    />
                  </div>
                </div>
                <div>
                  <div>Child w/o Bed Rate</div>
                  <div>
                    <input
                      className="w-100"
                      type="number"
                      name="child_wo_bed"
                      value={selectedRoomDetails.child_wo_bed}
                      onChange={handleDetailsChange}
                      disabled={
                        selectedRoomDetails.roomId &&
                          selectedRoomDetails.mealPlanID
                          ? false
                          : true
                      }
                    />
                  </div>
                </div>

                <span className="handle_add" onClick={handleAdd}>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_7248_3375"
                      style={{ maskType: "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="20"
                      height="20"
                    >
                      <rect width="20" height="20" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_7248_3375)">
                      <path
                        d="M9.3724 10.625V13.3333C9.3724 13.5107 9.43226 13.6592 9.55198 13.7787C9.67156 13.8985 9.82003 13.9583 9.9974 13.9583C10.1748 13.9583 10.3232 13.8985 10.4428 13.7787C10.5625 13.6592 10.6224 13.5107 10.6224 13.3333V10.625H13.3307C13.5081 10.625 13.6566 10.5651 13.7761 10.4454C13.8959 10.3258 13.9557 10.1774 13.9557 9.99999C13.9557 9.82263 13.8959 9.67416 13.7761 9.55457C13.6566 9.43485 13.5081 9.37499 13.3307 9.37499H10.6224V6.66666C10.6224 6.4893 10.5625 6.34082 10.4428 6.22124C10.3232 6.10152 10.1748 6.04166 9.9974 6.04166C9.82003 6.04166 9.67156 6.10152 9.55198 6.22124C9.43226 6.34082 9.3724 6.4893 9.3724 6.66666V9.37499H6.66406C6.4867 9.37499 6.33823 9.43485 6.21865 9.55457C6.09892 9.67416 6.03906 9.82263 6.03906 9.99999C6.03906 10.1774 6.09892 10.3258 6.21865 10.4454C6.33823 10.5651 6.4867 10.625 6.66406 10.625H9.3724ZM4.42052 17.0833C3.99955 17.0833 3.64323 16.9375 3.35156 16.6458C3.0599 16.3542 2.91406 15.9978 2.91406 15.5769V4.42311C2.91406 4.00214 3.0599 3.64582 3.35156 3.35416C3.64323 3.06249 3.99955 2.91666 4.42052 2.91666H15.5743C15.9952 2.91666 16.3516 3.06249 16.6432 3.35416C16.9349 3.64582 17.0807 4.00214 17.0807 4.42311V15.5769C17.0807 15.9978 16.9349 16.3542 16.6432 16.6458C16.3516 16.9375 15.9952 17.0833 15.5743 17.0833H4.42052ZM4.42052 15.8333H15.5743C15.6384 15.8333 15.6972 15.8066 15.7505 15.7531C15.804 15.6998 15.8307 15.641 15.8307 15.5769V4.42311C15.8307 4.35895 15.804 4.3002 15.7505 4.24686C15.6972 4.19339 15.6384 4.16666 15.5743 4.16666H4.42052C4.35635 4.16666 4.2976 4.19339 4.24427 4.24686C4.1908 4.3002 4.16406 4.35895 4.16406 4.42311V15.5769C4.16406 15.641 4.1908 15.6998 4.24427 15.7531C4.2976 15.8066 4.35635 15.8333 4.42052 15.8333Z"
                        fill="#009A50"
                      />
                    </g>
                  </svg>
                </span>
              </div>
            </div>
            {/* ); */}
            {/* })} */}
          </div>
          {/* </div>
              </div>
            );
          })} */}
          <div className="card-3d mt-10 mb-10  ">
            {selectedRoomDetailsArray.length > 0 ? (
              selectedRoomDetailsArray.map((item, index) => (
                <div className="room-card" key={index}>
                  <div className={["room-details"]}>
                    <div className="room-info">
                      <strong>Room:</strong> {item?.roomName}
                    </div>
                    <div className="room-info">
                      <strong>Meal Plan:</strong> {item?.mealPlanName}
                      {/* {item.mealPlanType} */}
                    </div>
                    <div className="room-info">
                      <strong>Price:</strong>{" "}
                      {formatIndianCurrency(item?.price)}
                    </div>
                    <div className="room-info">
                      <strong>Extra Adult:</strong>{" "}
                      {formatIndianCurrency(item?.extra_adult)}
                    </div>
                    <div className="room-info">
                      <strong>Child (with Bed):</strong>{" "}
                      {formatIndianCurrency(item?.child_w_bed)}
                    </div>
                    <div className="room-info">
                      <strong>Child (without Bed):</strong>{" "}
                      {formatIndianCurrency(item?.child_wo_bed)}
                    </div>
                  </div>
                  <div className={["room-actions"]}>
                    <span
                      className={["remove-icon"]}
                      onClick={() => handleRemove(index)}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                      >
                        <g clip-path="url(#clip0_1270_876)">
                          <path
                            d="M2.6811 0.5H11.3189C12.5235 0.5 13.5 1.47651 13.5 2.6811V11.3189C13.5 12.5235 12.5235 13.5 11.3189 13.5H2.6811C1.47651 13.5 0.5 12.5235 0.5 11.3189V2.6811C0.5 1.47651 1.47651 0.5 2.6811 0.5Z"
                            stroke="#009a50"
                          ></path>
                          <path
                            d="M10.5866 7H3.41333"
                            stroke="#009a50"
                            stroke-miterlimit="10"
                          ></path>
                        </g>
                        <defs>
                          <clipPath id="clip0_1270_876">
                            <rect width="14" height="14" fill="white"></rect>
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                  </div>
                </div>
              ))
            ) : (
              <div className="room_details_selected">
                <p>No room details added yet.</p>
              </div>
            )}
          </div>
          <button
            className="vendor_common_property mt-10"
            type="submit"
            onClick={handleOnUpdate}
            disabled={selectedRoomDetailsArray.length > 0 ? false : true}
          >
            Update
          </button>
        </div>
      </div>
      {/* </div> */}
      {/* </div> */}
    </>
  );
};

export default RatesBulkUpdate;
